import { render, staticRenderFns } from "./ConfigWebsiteCatalogueCreate.vue?vue&type=template&id=5c999ba8&scoped=true"
import script from "./ConfigWebsiteCatalogueCreate.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueCreate.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueCreate.vue?vue&type=style&index=0&id=5c999ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c999ba8",
  null
  
)

export default component.exports